/**
 * Identifies viewport and surrounding-layout dimensions across native scroll input.
 * @param container - Scroll viewport whose dimensions can clamp its position.
 * @param boundary - Optional surrounding layout participating in the resize.
 * @returns A stable dimension key; it does not include the current scroll position.
 */
export const getScrollLayoutRevision = (
  container: HTMLElement,
  boundary?: HTMLElement | null
): string =>
  [
    container.clientWidth,
    container.clientHeight,
    boundary?.clientWidth ?? 0,
    boundary?.clientHeight ?? 0,
  ].join(':');
